import { Amplify } from 'aws-amplify';
import { API_CONFIG } from '../config';

export const configureAmplify = () => {
  const hasSSOConfig = !!API_CONFIG.COGNITO_DOMAIN;

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: API_CONFIG.COGNITO_USER_POOL_ID,
        userPoolClientId: API_CONFIG.COGNITO_CLIENT_ID,
        loginWith: {
          username: true,
          ...(hasSSOConfig && {
            oauth: {
              domain: API_CONFIG.COGNITO_DOMAIN,
              scopes: ['openid', 'email', 'profile'],
              redirectSignIn: [API_CONFIG.COGNITO_REDIRECT_SIGN_IN],
              redirectSignOut: [API_CONFIG.COGNITO_REDIRECT_SIGN_OUT],
              responseType: 'code' as const,
            },
          }),
        },
      },
    },
  });
};
